/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    DeviceHubDocumentationResponse,
    IlluminateUser,
} from "../models/index";
import {
    DeviceHubDocumentationResponseFromJSON,
    DeviceHubDocumentationResponseToJSON,
    IlluminateUserFromJSON,
    IlluminateUserToJSON,
} from "../models/index";

/**
 *
 */
export class DeviceHubApi extends runtime.BaseAPI {
    /**
     * Documentation for the available SignalR hub methods and data types. Not a real API endpoint.
     */
    async getDeviceHubDocumentationRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceHubDocumentationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/devicehub/documentation`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceHubDocumentationResponseFromJSON(jsonValue),
        );
    }

    /**
     * Documentation for the available SignalR hub methods and data types. Not a real API endpoint.
     */
    async getDeviceHubDocumentation(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceHubDocumentationResponse> {
        const response = await this.getDeviceHubDocumentationRaw(initOverrides);
        return await response.value();
    }

    /**
     * SignalR negotiate endpoint
     */
    async negotiateRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<IlluminateUser>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/Negotiate`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            IlluminateUserFromJSON(jsonValue),
        );
    }

    /**
     * SignalR negotiate endpoint
     */
    async negotiate(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<IlluminateUser> {
        const response = await this.negotiateRaw(initOverrides);
        return await response.value();
    }
}
